import { useCallback } from "react";

import { useAccommodationHotelPolicyFormModelContext } from "../../../../../../context";

export const useReservationDefaultInitPeopleNum = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyFormModelContext();
	const { defaultInitPeopleNum } = viewModel;

	const isEdited = defaultInitPeopleNum.isEdited;
	const hasError = Boolean(defaultInitPeopleNum.error);

	const onSetDefaultInitPeopleNum = useCallback(
		(input: number | undefined) => {
			onSetViewModel([
				{
					key: "defaultInitPeopleNum",
					value: {
						...defaultInitPeopleNum,
						value: input ?? 0,
					},
				},
			]);
		},
		[defaultInitPeopleNum, onSetViewModel],
	);

	return {
		isEdited,
		hasError,

		defaultInitPeopleNum,
		onSetDefaultInitPeopleNum,
	};
};
